import * as React from "react";

import "./step-1-upload.scss";

import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {scopedState}            from "@Common/react/scoped-state";
import {UseState}               from "@Common/react/use-state";
import {chain}                  from "@Common/utils/fs";
import {FileSelector} from "./file-selector/file-selector";
import {Instruction}  from "./instruction/instruction";

export const Step1Upload = ({onNext, countryCode, onCancel}) => cs(
    consumeContext("apis"),
    ["data", (_, next) => UseState({
        initValue: {
            countryCode: "US",
            files: null,
        },
        next,
    })],
    ["apiError", (_, next) => UseState({next})],
    ["uploading", (_, next) => UseState({next})],
    ({data, apis, apiError, uploading}) => (
        <div className="step-1-upload-a1ik">
            <div className="content">
                <div className="form">
                    <div className="form-controls">
                        <div className="form-group file">
                            <div className="control-label" xd-qa-type="label" xd-qa-name="Upload Address List Select File">
                                Select File
                            </div>

                            {FileSelector({
                                state: chain(
                                    scopedState(data, ["files"]),
                                    (state) => ({
                                        value: state.value,
                                        onChange: (v) => {
                                            apiError.onChange(null);
                                            state.onChange(v);
                                        },
                                    }),
                                ),
                            })}
                        </div>

                        <div className="actions">
                            <button {...{
                                disabled: !data.value.files || apiError.value || uploading.value,
                                onClick: async () => {
                                    uploading.onChange(true);
                                    const result = await apis.next.mailing.uploadFile({file: data.value.files[0]});
                                    if (result.result === "failure") {
                                        apiError.onChange(result.errors?.msg ?? "Unknown error");
                                    } else {
                                        const [columns, ...rows] = result.data;
                                        onNext({
                                            fileName: data.value.files[0].name,
                                            filePath: result.fileName,
                                            keys: result.keys,
                                            columns,
                                            countryCode: countryCode ?? data.value.countryCode,
                                            rows,
                                        });
                                    }
                                    uploading.onChange(false);
                                },
                                "xd-qa-type": "button",
                                "xd-qa-name": "Upload Address List Upload",
                            }}>
                                Upload
                            </button>
                        </div>
                    </div>

                    {apiError.value && (
                        <div className="error">
                            {apiError.value}
                        </div>
                    )}

                    {countryCode && (
                        <div className="country-instruction">
                            <div className="notice" xd-qa-type="label" xd-qa-name="Upload Address List Country Disclaimer">
                                All uploaded addresses must be within {countryCode === "CA" ? "Canada" : "the US"} to ensure accurate delivery.
                            </div>
                            {countryCode === "CA" && (
                                <div className="no-verification" xd-qa-type="label" xd-qa-name="Upload Address List Verification Disclaimer">
                                    Please review your uploaded list carefully, as the system will not validate uploaded <b>Canadian</b> address lists after creation and non-canadian addresses will be auto failed.
                                </div>
                            )}
                        </div>
                    )}
                </div>


                {Instruction({})}
            </div>

            <div className="footer">
                <button
                    onClick={onCancel}
                    xd-qa-type="button"
                    xd-qa-name="Back"
                >
                    Back
                </button>
            </div>

        </div>
    ),
);